import React, { Component } from 'react';
import { withTranslation }  from 'react-i18next';
import PropTypes            from 'prop-types';
import ReactPaginate        from 'react-paginate';
import './styles.scss';

class Pagination extends Component {
  state = {
    totalPages: 1,
  };

  render() {
    const { t, onChangePage, totalElements } = this.props;
    const { totalPages } = this.state;
    const ceil = Math.ceil(totalElements / 10);
    if (totalPages !== ceil) {
      this.setState(() => ({
        totalPages: ceil,
      }));
    }
    return (
      <div>
        {totalPages > 0 && (
          <ReactPaginate
            previousLabel={t('previous')}
            nextLabel={t('next')}
            breakLabel="..."
            breakClassName="break-me"
            pageCount={totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={onChangePage}
            containerClassName="pagination"
            subContainerClassName="pages pagination"
            activeClassName="active"
          />
        )}
      </div>
    );
  }
}

Pagination.propTypes = {
  totalElements: PropTypes.number,
  onChangePage: PropTypes.func,
};

Pagination.defaultProps = {
  totalElements: 0,
  onChangePage: () => {},
};

export default withTranslation()(Pagination);
